import React, { useState } from 'react';
import Chatbot from './Chatbot';
import './Copilot.css';
import { copilotApi } from '../api/chatApi';

const Copilot = () => {
  const [selectedThreadId, setSelectedThreadId] = useState<number | undefined>(undefined);

  const {
    data: conversations,
    isLoading,
    isError,
  } = copilotApi.useApiPortalV1ChatCopilotListQuery();

  return (
    <div
      data-testid="admin-copilot-page"
      style={{
        display: 'flex',
        padding: '20px',
        maxHeight: 'calc(100vh - 50px)',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <div
        data-testid="admin-copilot-content"
        style={{
          flex: 1,
          overflowY: 'auto',
          maxHeight: 'calc(100vh - 50px)',
        }}
      >
        <Chatbot 
          selectedThreadKey={selectedThreadId} 
          onThreadChange={setSelectedThreadId}
          conversations={conversations}
          conversationsLoading={isLoading}
          conversationsError={isError}
        />
      </div>
    </div>
  );
};

export default Copilot;
